import React from "react";
import { SPECS as specs } from "../config/product";

const Specs = () => {
  return (
    <section
      id="specs"
      data-testid="specs-section"
      className="relative min-h-screen py-32 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16 max-w-xl">
          <span className="font-serif-accent text-[#ffd074] text-xl">— Ficha técnica</span>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.9] font-bold tracking-tighter mt-3">
            Los
            <br />
            <span className="holo-text">datos.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 rounded-3xl overflow-hidden border border-white/10">
          {specs.map((s, i) => (
            <div
              key={s.label}
              data-testid={`spec-item-${i}`}
              className="bg-[#070707] p-6 md:p-8 hover:bg-[#0d0d0d] transition-colors duration-300 group"
            >
              <div className="font-body text-xs text-white/40 uppercase tracking-[0.2em] mb-3">
                {s.label}
              </div>
              <div className="font-display text-2xl md:text-3xl font-bold tracking-tight group-hover:holo-text transition-all">
                {s.value}
              </div>
            </div>
          ))}
        </div>

        {/* Pull-quote */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-2 font-display text-7xl text-white/10 select-none">"</div>
          <blockquote className="md:col-span-8 font-serif-accent text-3xl md:text-4xl leading-snug text-white/90">
            Dejar el móvil cargando toda la noche desgasta la batería. FullStop lo
            evita: corta la corriente en cuanto llega al 100%.
          </blockquote>
          <div className="md:col-span-2 font-body text-sm text-white/40">
            <div className="text-white">Carga segura</div>
            <div>Menos desgaste</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specs;
